const INFO = {
	main: {
		title: "Alaphat Magezi",
		name: "Alaphat Magezi",
		email: "a.magezi44@gmail.com",
		logo: "./logo.png",
	},

	socials: {
		twitter: "https://www.linkedin.com/in/alaphat-magezi/",
		github: "https://github.com/arafats1",
		linkedin: "https://www.linkedin.com/in/alaphat-magezi/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-stack Web and Mobile Software Engineer.",
		description:
			"Full-Stack Web and Mobile Software Engineer with over 4 years of experience building large-scale systems using the latest technologies across web and mobile platforms. Furthermore, I have architected systems and orchestrated teams in developing resilient software systems.",
	},

	about: {
		title: "I’m Alaphat Magezi. I live in Kampala, Uganda where I design and build for the future.",
		description:
		"Over the years, I’ve worked on a variety of projects. If you’re interested in exploring any of my work, feel free to check it out and share any ideas or suggestions for improvement. I believe collaboration and feedback are invaluable for learning and growth, and I’m always open to fresh perspectives and innovative ideas."
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Abramaccess - Patient-Centered Healthcare Records Platform",
			description:
				"Abramaccess is a comprehensive healthcare records management platform that empowers patients to securely manage and share their medical history. Built with modern web technologies, it features secure storage of medical records, chronological history viewing, temporary access code generation for healthcare providers, and AI-powered smart analysis of medical documents. The platform ensures data privacy while making healthcare information easily accessible to authorized parties.",
			logo: "https://www.abramaccess.com/_next/image?url=%2Flogo22.png&w=128&q=75",
			linkText: "View Platform",
			link: "https://www.abramaccess.com/",
		},
		{
			title: "YoKlinic - A Telemedicine Marketplace",
			description:
				"A telemedicine platform that connects patients with certified healthcare professionals and health facilities for real-time video consultations, e-prescriptions, and health monitoring. YoKlinic is a secure, reliable, and easy-to-use platform that is accessible from anywhere in the world. Built using NextJS, Node.js, AWS RDS, Firebase, Twilio, SendGrid, and Flutterwave.",
				logo: "../yo.png",
			linkText: "View Platform",
			link: "https://www.yoklinic.com/",
		},

		{
			title: "Market Doctors App",
			description:
				"MarketDoctors is a social-impact healthcare app focused on delivering affordable and accessible healthcare services across Nigeria. This app offers users the convenience of healthcare at their doorstep, with features including scheduling medical consultations, health assessments, wellness management, and access to qualified healthcare providers. Built using Flutter, Node.js, Digital Ocean",
			logo: "../mk.png",
			linkText: "View App on Playstore",
			link: "https://play.google.com/store/apps/details?id=com.market_doctor",
		},

		{
			title: "Moby CHP App for Rural Healthcare Services",
			description:
				"Mobiklinic is a tool for Community Health Providers (CHPs) to streamline their interactions with community members. The app allows CHPs to register patients and follow up, has a geolocation feature to locate near by hospitals and ambulances. It also has an AI chatbot and a live doctor chat. Built Using React Native, Node.js, AWS RDS",
			logo: "https://play-lh.googleusercontent.com/_yREiy8tBuWxJFwxTJ-3NVdwjKH5ei6Xpg2DXh62hUNG4EgbQaugGlEQIlTFdGAzcQ=w240-h480-rw",
			linkText: "View App on Playstore",
			link: "https://play.google.com/store/apps/details?id=com.mobiklinicapp",
		},

	

		{
			title: "Uganda National Youth Council (NYC) Open Portal Web App",
			description:
				" The NYC Open Portal is a platform that provides information on the National Youth Council of Uganda. The platform is designed to provide information on the council, its members, and the services it offers. The platform also provides information on the council's activities, events, projects and their budgets. Built using NextJS, Node.js, AWS RDS, Google Maps API",
			logo: "../logonyc.png",
			linkText: "View Portal",
			link: "https://open.nyc.go.ug/",
		},

		{
			title: "Facial Biometrics Integration Project",
			description:
				"Facial Biometrics Integration Project was a project that integrates Simprints facial recognition technology into the existing React Native Android App. The project is designed to provide a secure and reliable way to register and identify patients in underseved areas using facial recognition technology. The project is built using Java, Simprints, React Native, Node.js, AWS RDS",
			logo: "https://www.simprints.com/wp-content/uploads/2024/05/simprints-logo-lightbg.svg",
			linkText: "Project APK",
			link: "https://drive.google.com/file/d/1KI8Dxm8Ze-AFgqLbM3GM6j4YWq18Avv8/view",
		},
	],
};

export default INFO;
